import React from 'react';
import { ArrowRight } from 'lucide-react';

const CaseStudyCard = ({
  icon,
  title,
  description,
  features = [],
  imageUrl,
  className = ''
}) => {
  return (
    <div className={`bg-white border-2 border-purple-200 rounded-2xl overflow-hidden hover:border-purple-400 transition-all duration-300 hover:shadow-xl shadow-lg ${className}`}>
      {/* Image Section */}
      {imageUrl && (
        <div className="relative h-64 overflow-hidden bg-gradient-to-br from-purple-50 to-pink-50">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-white/80 to-transparent"></div>
        </div>
      )}

      {/* Content Section */}
      <div className="p-8">
        {/* Icon and Title */}
        <div className="flex items-center gap-4 mb-4">
          {icon && (
            <div className="text-purple-500 text-5xl">
              {icon}
            </div>
          )}
          <h3 className="text-3xl font-bold text-gray-800">{title}</h3>
        </div>

        {/* Description */}
        <p className="text-gray-600 text-lg mb-6 leading-relaxed">
          {description}
        </p>

        {/* Features List */}
        {features.length > 0 && (
          <div className="mb-6">
            <h4 className="text-xl font-semibold text-purple-600 mb-3">Key Features</h4>
            <ul className="space-y-2">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-gray-700">
                  <ArrowRight className="w-5 h-5 text-purple-500 flex-shrink-0 mt-0.5" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Decorative Bottom Border */}
        <div className="mt-6 pt-4 border-t border-purple-200">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-500">App Development Project</span>
            <div className="flex gap-1">
              <div className="w-2 h-2 rounded-full bg-purple-500"></div>
              <div className="w-2 h-2 rounded-full bg-pink-500"></div>
              <div className="w-2 h-2 rounded-full bg-blue-500"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseStudyCard;
